/**
 * 竞赛资讯接口（v0.3 竞赛资讯分类 + AI 智能读取）。契约见后端 routes/news.route.ts：
 *   POST /news/parse     → 201 {news, parsed}                  （organizer/admin：粘贴原文，AI 出草稿）
 *   GET  /news           → {news: NewsDto[]}                    （organizer/admin：资讯库列表）
 *   GET  /news/:id       → {news}                               （organizer/admin：单条）
 *   PATCH /news/:id/confirm → 201 {event, news}                 （organizer/admin：确认草稿 → 建赛事）
 */
import { api } from './client.js';
import type { NewsConfirmDto, NewsDto, NewsListDto, NewsParseDto } from './types.js';

export interface ParseNewsPayload {
  rawText: string;
  sourceUrl?: string | null;
}

export interface ConfirmNewsPayload {
  name: string;
  season?: string;
  scope?: 'common' | 'exclusive';
  schools?: string[];
}

export const newsApi = {
  /** 解析竞赛原文 → AI 结构化草稿（不建赛事） */
  parse: (payload: ParseNewsPayload): Promise<NewsParseDto> =>
    api.post<NewsParseDto>('/news/parse', payload),

  /** 资讯库列表 */
  list: (): Promise<NewsListDto> => api.get<NewsListDto>('/news'),

  /** 单条资讯 */
  get: (id: string): Promise<{ news: NewsDto }> => api.get<{ news: NewsDto }>(`/news/${encodeURIComponent(id)}`),

  /** 确认草稿 → 建赛事 + 写 event_schools → news 置 confirmed */
  confirm: (id: string, payload: ConfirmNewsPayload): Promise<NewsConfirmDto> =>
    api.patch<NewsConfirmDto>(`/news/${encodeURIComponent(id)}/confirm`, payload),
};
